import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const homePagePlugin = createPlugin({
  id: 'appfolio-homepage',
  routes: {
    root: rootRouteRef,
  },
});

export const HomePage = homePagePlugin.provide(
  createRoutableExtension({
    name: 'HomePage',
    component: () => import('./components/HomePage').then(m => m.HomePage),
    mountPoint: rootRouteRef,
  }),
);
